import Content from './Content';
import Footer from './Footer';
import Header from './Header';
import Wrapper from './Wrapper';

const NewLandingPageLayout = {
  Header,
  Wrapper,
  Footer,
  Content,
};

export default NewLandingPageLayout;
